const sections = document.querySelectorAll(".scrolling-slider-section-v1 .div_main section");
const dotNav = document.getElementById("dotNav");

// Hide all sections initially except the first
sections.forEach((section, i) => {
  section.style.display = i === 0 ? "block" : "none";
});

// Create dot click handlers
const dots = dotNav.querySelectorAll(".nav-dot");

dots.forEach((dot, i) => {
  dot.addEventListener("click", () => {
    // Hide all sections
    sections.forEach(section => section.style.display = "none");

    // Show the selected section
    sections[i].style.display = "block";

    // Update active dot styling
    dots.forEach(d => d.classList.remove("is-active"));
    dot.classList.add("is-active");
  });
});


// Reveal animation logic (optional)
document.querySelectorAll(".reveal-group").forEach(el => {
  if (el.children.length === 0 && el.textContent.trim() !== '') {
    const text = el.textContent;
    el.textContent = '';
    [...text].forEach((char, i) => {
      const span = document.createElement("span");
      span.textContent = char;
      span.style.transitionDelay = `${i * 40}ms`;
      el.appendChild(span);
    });
  }
});

// Optional: trigger reveal animation on first load
window.addEventListener("load", () => {
  const firstSection = sections[0];
  const videoContainer = firstSection.querySelector(".video-container");
  const reveals = firstSection.querySelectorAll(".reveal-group");
  if (videoContainer) videoContainer.classList.add("visible");

  reveals.forEach((reveal, index) => {
    reveal.classList.remove("visible", "revealing");
    setTimeout(() => {
      reveal.classList.add("revealing");
      setTimeout(() => {
        reveal.classList.remove("revealing");
        reveal.classList.add("visible");
      }, 600);
    }, index * 300);
  });
});

/*-----------------------------------------------------------
      START: Scroll to products
-----------------------------------------------------------*/
const boxspringLinks = document.querySelectorAll('.scroll_to_product_listings');
  if (boxspringLinks) { 
    boxspringLinks.forEach((boxspringLink) => {
      boxspringLink.addEventListener('click', function(e) {
        e.preventDefault();
        
        const target = document.querySelector('#ProductGridContainer');
        
        // Scroll to the element smoothly
        const headerHeight = document.querySelector('.section-header') ? document.querySelector('.section-header').offsetHeight : 0;
    
        window.scrollTo({
            top: target.offsetTop - headerHeight,
            behavior: 'smooth'
        });
      
    });
  });
}